
// takes an object along with mappings to manually render left-hand text
// to values from an object

export function customKeysForObjectData(obj: Record<string, any>, fieldMappings: Record<string, any>): string {
    const data = Object.keys(obj).map(key => fieldMappings[key] ? [fieldMappings[key], obj[key]] : null)
    .map(arr => arr ? arr[0] + arr[1] + "\n" : null).join("\n")
    
    return data
  }